module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAABTUlEQVR4AZRRPUsDQRCd2UsMWmrhByJYiR+NYCOWGrBJoimsRLCzsFQIuSS7uZhT1M4q2FmKiIkWKRQbU4gWduYPaECwECw0ZjPOHihEA5rlPZh9M29mPwS0sJRSIiPzUWbp30bXOZ20aPyG5+wB0cGfxlzu1r8hT3Z0vV5CgHt/e8dI0pnLecZMpjC4JQsD3K0Brnvc9VR5uCTANUCwE+nIYiwWfDFFIqvOxqBGVx9A145TGDWioZT5Pl21SkAwhYjrSRnZNPoXBZBe4W69LPSgpmI2m+9WqtjpQzxn0xABbCdUeJfzDRB2OrIqUARZfWT26yru++DtkB9gmBseJVU4xvoveHe0ZehCtAUmOHuHQCEinOZJZQ3vy3xMDjnzA57RaLY9W7ECeoaryryvgYVLSi28ctwU30aTjcejzz4U8wjoplJh82dGbspPAAAA//+gcAfcAAAABklEQVQDAPFCbCwANgtKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dg-success.png
// module id = omcm
// module chunks = 167